<template>
    <div class="ReportGroupFilterBar">
        <div class="container-fluid">
          <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc margin-left-2Perc"> 
                <div class="col-md-1 col-lg-1 text-align-right">
                    Group(s)
                </div>    
                <div class="col-md-3 col-lg-3 padding-left-0px">
                  <select class="form-control Padding-right-0px" v-model="getSelectedGroupObj">
                    <option value=-1 disabled>Select</option>
                    <option v-for="groupObj in getGroupList" v-bind:key="groupObj.GroupId" v-bind:value="groupObj">{{ groupObj.GroupName }}</option>
                  </select>
                </div> 
                <div class="col-md-1 col-lg-1 text-align-right width-6Perc padding-left-right-0Px">
                    Milestone(s)
                </div>    
                <div class="col-md-2 col-lg-2">
                    <select class="form-control Padding-right-0px" v-model="selectedMilestoneInfoObj" :disabled="disableMilestoneInfoDropDown">
                      <option value=-1 disabled>Select</option>
                      <option v-for="milestoneInfoObj in getMilestoneInfoList" v-bind:key="milestoneInfoObj.MilestoneInfoId" v-bind:value="milestoneInfoObj">{{ milestoneInfoObj.Title }}</option>
                    </select>
                </div>
                <div class="col-md-1 col-lg-1 text-align-right width-6Perc padding-left-right-0Px">
                    Milestone Title
                </div>    
                <div class="col-md-2 col-lg-2 Padding-left-0px">
                  <select class="form-control Padding-right-0px" v-model="selectedMilestoneTitleObj" :disabled="disableMilestoneTitleDropDown || disableMilestoneInfoDropDown">
                    <option value=null>All</option>
                    <option v-for="milestoneTitleObj in getMilestoneTitleList" v-bind:key="milestoneTitleObj.MilestoneId" v-bind:value="milestoneTitleObj">{{ milestoneTitleObj.Title }}</option>
                  </select>
                </div>
                <div class="col-md-1 col-lg-1">
                  <!-- ToDo: Track this -->
                    <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, false)">View</button>
                </div>
                <div class="col-md-1 col-lg-1">
                  <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event, true)" v-if="getShowExportState">Export</button>
                </div>
          </div>
          <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
          <!-- Show Spinner -->
          <div class="animationload" v-show="showSpinner">
            <div class="osahanloading"></div>
          </div>  
          <loader></loader>    
        </div>
    </div>    
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import { groupService } from '@/server-util/group-service'
import { milestoneService } from '@/server-util/milestone-service'
import AlertBox from '@/components/AlertOverlay'
export default {
  props: ['showExport'],
  created: function () {
    this.getGroups()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedMilestoneInfoObj: -1,
      selectedGroupObj: -1,
      selectedMilestoneTitleObj: null,
      milestoneTitleList: [],
      disableMilestoneTitleDropDown: false,
      disableMilestoneInfoDropDown: true
    }
  },
  methods: {
    checkAndEmit: function (event, isExportBtnClicked) {
      if (this.getSelectedGroupObj !== -1) {
        if (this.selectedMilestoneInfoObj !== -1) {
          if (this.selectedMilestoneTitleObj !== -1) {
            // AK: Emit selected Group, MilestoneInfo and Milestone Title Obj
            var objToPass = {
              selectedMilestoneInfoObj: this.selectedMilestoneInfoObj,
              selectedGroupObj: this.getSelectedGroupObj,
              selectedMilestoneTitleObj: this.selectedMilestoneTitleObj
            }
            this.$emit('selectedMilestoneInfoAndGroupObj', objToPass)
            if (isExportBtnClicked) {
              this.$emit('isExportBtnClicked', true)
              this.$emit('isViewBtnClicked', false)
            } else {
              this.$emit('isExportBtnClicked', false)
              this.$emit('isViewBtnClicked', true)
            }
          } else {

          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
          'Please select a milestone.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getGroups: function () {
      var storeObj = this.$store
      var _this = this
      var isGroupListPresent = false
      if (
        storeObj.state.access_token !== undefined ||
        storeObj.state.access_token !== null ||
        storeObj.state.access_token !== ''
      ) {
        // AK: Check weather Grouplist is already present or not?
        if (storeObj.state.groupList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          isGroupListPresent = false
        } else {
          _this.getMilestoneInfoFromServer()
          isGroupListPresent = true
        }
        groupService.listGroups(storeObj.state.access_token).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupList = responseObj.data
              // AK: Hide Spinner after recieving group list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              // AK: If group list is loading first time then call next server API after this
              if (!isGroupListPresent) {
                _this.getMilestoneInfoFromServer()
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('Access Token is NULL hence declined LOADING GROUP LIST')
      }
    },
    getMilestoneInfoFromServer: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        // AK: If we don't have milestone list with us, then only show spinner to user.
        if (storeObj.state.milestoneInfoList.length === 0) {
          this.$store.state.isLoading = true
        }
        var _this = this
        milestoneService
          .getMilestoneInformation(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.$store.state.isLoading = false
              storeObj.state.milestoneInfoList = responseObj.data
              if (storeObj.state.milestoneInfoList.length === 0) {
                this.showAlertDialog = true
                this.errorMsg = 'No Milestone(s) found.'
              }
              if (_this.$store.state.isLoading) {
                this.$store.state.isLoading = false
              }
            } else {
              if (_this.$store.state.isLoading) {
                this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading) {
              this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED LOADING MILESTONE INFO LIST OPERATION.')
      }
    },
    getMilestoneTitlesFromServer: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== '' && storeObj.state.access_token !== null) {
        this.$store.state.isLoading = true
        var _this = this
        milestoneService
          .getMilestoneTitleList(
            storeObj.state.access_token,
            _this.selectedMilestoneInfoObj.MilestoneInfoId,
            _this.getSelectedGroupObj.GroupId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              this.milestoneTitleList = responseObj.data
              if (this.milestoneTitleList.length === 0) {
                this.disableMilestoneTitleDropDown = true
                this.showAlertDialog = true
                this.errorMsg = 'No \'' + this.selectedMilestoneInfoObj.Title + '\' milestones created for this group.'
                this.selectedMilestoneInfoObj = -1
                // this.selectedGroupObj = -1
              } else {
                this.disableMilestoneTitleDropDown = false
              }
              this.$store.state.isLoading = false
            } else {
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log('FOUND EMPTY ACCESS TOKEN HENCE DECLINED LOADING ASSOCIATED MILESTONE TITLE LIST OPERATION.')
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getShowExportState: {
      get: function () {
        return this.showExport
      }
    },
    getMilestoneInfoList: {
      get: function () {
        return this.$store.state.milestoneInfoList
      }
    },
    getGroupList: {
      get: function () {
        return this.$store.state.groupList
      }
    },
    getMilestoneTitleList: {
      get: function () {
        return this.milestoneTitleList
      }
    },
    getSelectedGroupObj: {
      get: function () {
        return this.selectedGroupObj
      },
      set: function (newValue) {
        this.selectedGroupObj = newValue
        if (newValue !== -1) {
          this.disableMilestoneInfoDropDown = false
        } else {
          this.disableMilestoneInfoDropDown = true
        }
      }
    }
  },
  watch: {
    getSelectedGroupObj: function (newValue, oldValue) {
      this.selectedMilestoneInfoObj = -1
      this.selectedMilestoneTitleObj = null
    },
    selectedMilestoneInfoObj: function (newValue, oldValue) {
      if (newValue !== -1) {
        this.getMilestoneTitlesFromServer()
      }
    }
  },
  name: 'ReportGroupFilterBar'
}
</script>

<style scoped>
.ReportFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.font-size-18px{
    font-size: 18px !important;
}
.text-align-right{
  text-align: right;
}
.margin-left-2Perc{
  margin-left:2%;
}
.padding-left-0px{
  padding-left:0px;
}
.width-6Perc{
  width:6%;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/milestone/MilestoneWiseFilterBar.vue